// extracted by mini-css-extract-plugin
export default {"guide-view":"webbook-guide-view_guide-view__gD0AX","imgContainer":"webbook-guide-view_imgContainer__4QAoL"};